import { useEffect } from "react";
import { TimeSerieFilesCard } from "./card";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { TimeSerieFilesTable } from "./table";

export default function TimeSerieFiles() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Fichiers de séries temporelles");
  }, []);

  return (
    <Routes>
      <Route index element={<TimeSerieFilesTable />} />
      <Route path=":id" element={<TimeSerieFilesCard />} />
    </Routes>
  );
}
